<template>
    <b-card no-body>
        <b-card-header header-tag="header" class="p-1" role="tab">
            <b-button
                block
                v-b-toggle="accordionName"
                :variant="variant"
                class="text-left"
                ><h5 class="my-0 py-0">
                    <b-icon
                        class="mr-2"
                        :icon="plusaccordion1 ? 'dash-circle' : 'plus-circle'"
                    />
                        <slot name="titlebar"></slot>
                </h5></b-button
            >
        </b-card-header>
        <b-collapse
            :id="accordionName"            
            role="tabpanel"
            v-model="plusaccordion1"
        >
            <b-card-body>
                <b-card-text>
                <slot></slot>
                </b-card-text>
            </b-card-body>
        </b-collapse>
    </b-card>
</template>

<script>
export default {
    name: "AccordionItem",
    props: {        
        variant: {type: String, default: "primary"}
    },
    data(){
        return {
            plusaccordion1: false,
            accordionName: uuid4(),
        }
    }
};


function uuid4()
{
  function hex (s, b)
  {
    return s +
      (b >>> 4   ).toString (16) +  // high nibble
      (b & 0b1111).toString (16);   // low nibble
  }

  let r = crypto.getRandomValues (new Uint8Array (16));

  r[6] = r[6] >>> 4 | 0b01000000; // Set type 4: 0100
  r[8] = r[8] >>> 3 | 0b10000000; // Set variant: 100

  return r.slice ( 0,  4).reduce (hex, '' ) +
         r.slice ( 4,  6).reduce (hex, '-') +
         r.slice ( 6,  8).reduce (hex, '-') +
         r.slice ( 8, 10).reduce (hex, '-') +
         r.slice (10, 16).reduce (hex, '-');
}
</script>